module.exports = __webpack_public_path__ + "static/media/xxx.b0775bf9.mp3";